import React from 'react';

import { TableCell } from '@mui/material';
import { useTranslation } from 'react-i18next';

import TableTotalFooter from '../../../../components/TableTotalFooter';
import { IRegistrationType } from '../../../../types/registration-type';
import { IStaffStatus } from '../../../../types/staff-status';
import { ArrayUtils } from '../../../../utils/array.utils';

interface IProps {
  statistics: IStaffStatus[];
  statuses: string[];
}

const StaffStatusListFooter = React.memo(({ statistics, statuses }: IProps) => {
  const { t } = useTranslation();

  const renderTotalRow = React.useMemo(
    () =>
      statuses
        .map((status) => {
          const filtered = statistics.filter((item) => item.code === status);

          return [IRegistrationType.new, IRegistrationType.old, 'total'].map((key) => (
            <TableCell key={`${status}_${key}`}>
              {ArrayUtils.calculateTotal(filtered, key as keyof IStaffStatus)}
            </TableCell>
          ));
        })
        .flat(),
    [statistics, statuses],
  );

  return (
    <TableTotalFooter>
      <TableCell sx={{ fontWeight: 'bold' }}>{t(`general.total`)}</TableCell>
      {renderTotalRow}
      <TableCell>{ArrayUtils.calculateTotal(statistics, 'total')}</TableCell>
    </TableTotalFooter>
  );
});

export default StaffStatusListFooter;
